import React from "react";
import { NavLink } from "react-router-dom";
import AuthContext from "../../../../AuthContext";

const MtzTodoMessages = () => {
  const me = React.useContext(AuthContext);

  const handleOpen = async (linkType) => {
    if (!me || Object.keys(me).length === 0 || !me.userId) {
      const ok =
        linkType === "join"
          ? await window.createMtzConfirm("Please login to join a networking company group")
          : await window.createMtzConfirm("Please login to create a networking company group");

      if (!ok) return;
      else {
        linkType === "join"
          ? (window.location.href = "/login?redirectUrl=" + "/search?type=GROUP")
          : (window.location.href = "/login?redirectUrl=" + "me/groups/add");
        return;
      }
    }
  };

  return (
    <div className="mtz-card border-dark border">
      {!me.userId && (
        <div className="alert alert-warning">
          <div className="btn" data-toggle='collapse' data-target='#todolist'>
            <div>New to MyTradeZone?</div>
            <div>It's free, and only takes a few minutes to join!</div>
          </div>

          <ul id='todolist' className="collapse">
            <li>Receive a unique profile URL</li>
            <li>Your own company profile page</li>
            <li>Post your products and services</li>
            <li>Create or join networking groups</li>
            <li>Text and video chat tools</li>
            <li>Note-taking tools</li>
            <li>CRM & email marketing tools</li>
          </ul>
        </div>
      )}

      <div>
        <NavLink
          to={me.userId ? "/search?type=GROUP" : window.location.pathname}
          onClick={() => me && handleOpen("join")}
          style={{ textDecoration: "none" }}
        >
          Join a Networking Group
        </NavLink>
      </div>

      <div>
        <NavLink
          to={me.userId ? "/me/groups" : window.location.pathname}
          onClick={() => me && handleOpen("create")}
          style={{ textDecoration: "none" }}
        >
          Create your own Networking Group
        </NavLink>
      </div>

      <div>
        <NavLink
          to={me.userId ? "/me/rfqs/add" : window.location.pathname}
          onClick={() => me && handleOpen("create")}
          style={{ textDecoration: "none" }}
        >
          Create RFQ
        </NavLink>
      </div>

      <div>
        <NavLink
          to={'/faqs/how-to-create-an-event'}
          onClick={() => me && handleOpen("create")}
          style={{ textDecoration: "none" }}
        >
          Create and Host an Event
        </NavLink>
      </div>
    </div>
  );
};

export default MtzTodoMessages;
